import { render, staticRenderFns } from "./Saldo.vue?vue&type=template&id=63a03bd2&scoped=true"
import script from "./Saldo.vue?vue&type=script&lang=js"
export * from "./Saldo.vue?vue&type=script&lang=js"
import style0 from "./Saldo.vue?vue&type=style&index=0&id=63a03bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a03bd2",
  null
  
)

export default component.exports